/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Footer_Support_EmailInputs */

const en_wc_footer_support_email = /** @type {(inputs: Wc_Footer_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`support@wordcraftapp.com`)
};

/**
* | output |
* | --- |
* | "support@wordcraftapp.com" |
*
* @param {Wc_Footer_Support_EmailInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_footer_support_email = /** @type {((inputs?: Wc_Footer_Support_EmailInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Footer_Support_EmailInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_footer_support_email(inputs)
});
export { wc_footer_support_email as "wc.footer.support_email" }